export default __webpack_public_path__ + "static/media/氨氮（水杨酸法）.7605dbcd.png";